import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { LogoMark, LogoWord } from "../Logo";
import { scrollToId, track } from "../../lib/api";

const LINKS = [
  { label: "Le produit", id: "produit" },
  { label: "Fonctionnement", id: "fonctionnement" },
  { label: "Flotte", id: "flotte" },
  { label: "Prix", id: "prix" },
  { label: "FAQ", id: "faq" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-[#2E333D]/60 bg-[#0C0D0E]/85 backdrop-blur-xl" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button onClick={() => go("hero")} className="flex items-center gap-2.5" data-testid="nav-logo" aria-label="STOCKBOX 8 - retour en haut">
          <LogoMark />
          <LogoWord />
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-link-${l.id}`}
              className="text-sm text-gray-400 hover:text-[#FFC700] transition-colors font-medium">
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span className="hidden lg:inline-flex font-mono text-[10px] uppercase tracking-widest text-[#FFC700] border border-[#FFC700]/40 rounded-full px-3 py-1">
            Pré-lancement — France
          </span>
          <button
            onClick={() => { track("click_cta_hero", { position: "nav" }); go("questionnaire"); }}
            data-testid="nav-cta-button"
            className="hidden sm:inline-flex items-center gap-2 bg-[#FFC700] text-[#0C0D0E] font-semibold text-sm px-5 py-2.5 rounded-full hover:bg-[#FFD83D] transition-colors"
          >
            Être informé <ArrowRight size={16} />
          </button>
          <button className="md:hidden text-gray-300 p-2" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#2E333D] bg-[#0C0D0E] px-4 py-4 space-y-1" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-mobile-link-${l.id}`}
              className="block w-full text-left py-3 text-base text-gray-300 hover:text-[#FFC700]">
              {l.label}
            </button>
          ))}
          <button
            onClick={() => { track("click_cta_hero", { position: "nav_mobile" }); go("questionnaire"); }}
            data-testid="nav-mobile-cta-button"
            className="mt-2 w-full bg-[#FFC700] text-[#0C0D0E] font-semibold px-5 py-3.5 rounded-full"
          >
            Être informé du lancement
          </button>
        </div>
      )}
    </header>
  );
}
